<div class="container">
  <mic-breadcrumb id="rerun-rework-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('rerunReworkReasonText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title rerun-rework-reason-heading" id="rerun-rework-heading">
    {{ translationService.translate('rerunReworkReasonsText') }}
  </h2>

  <div class="action-bar">
    <button id="clear-filters" type="button" mat-flat-button color="accent" class="btn-clear" (click)="clearFilters()">
      <mat-icon>refresh</mat-icon> {{ translationService.translate('clearSelectionText') }}
    </button>
    <button mat-flat-button color="primary" class="btn-export" (click)="openExportModal()">
      <mat-icon>download</mat-icon>
      {{ translationService.translate('exportButtonText') }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          [data]="rerunReasonList"
          formControlName="rerunReason"
          [widthConfig]="{ width: '100%' }"
          [label]="translationService.translate('rerunReworkReasonText')"
          placeholder="{{ translationService.translate('selectTypeText') }}"
          [multiple]="true"
          subscriptSizing="dynamic"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          [data]="descriptionList"
          formControlName="description"
          [label]="translationService.translate('descriptionText')"
          placeholder="{{ translationService.translate('selectDescText') }}"
          [multiple]="true"
          [widthConfig]="{ width: '100%' }"
          subscriptSizing="dynamic"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          [data]="typeList"
          formControlName="type"
          [label]="translationService.translate('typeColumnText')"
          placeholder="{{ translationService.translate('selectTypeText') }}"
          [multiple]="true"
          [widthConfig]="{ width: '100%' }"
          subscriptSizing="dynamic"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          [data]="cureProcessList"
          formControlName="cureProcess"
          [label]="translationService.translate('cureProcessText')"
          placeholder="{{ translationService.translate('selectTypeText') }}"
          [multiple]="true"
          [widthConfig]="{ width: '100%' }"
          subscriptSizing="dynamic"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          [data]="activeList"
          formControlName="active"
          [label]="translationService.translate('activeText')"
          placeholder="{{ translationService.translate('selectActionText') }}"
          [multiple]="true"
          [widthConfig]="{ width: '100%' }"
          subscriptSizing="dynamic"
        ></mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  <div id="rerun-rework-reason-table" class="cam-table table-container">
    <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
    </mic-table>
  </div>
</div>
